import React from 'react'
import { useTranslation } from 'react-i18next'
import { Banner } from '@node-space/storybook-components/dist/Banner'

export const OfflineBanner = () => {
  const { t } = useTranslation()

  return <Banner key="offlineBanner" message={t('errorMessages.errorOffline')} state="warning" />
}
